import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import React from "react";
import StarRateIcon from "@mui/icons-material/StarRate";
import { Link, useNavigate } from "react-router-dom";

const VendorFlatCard = ({
  title,
  image,
  des = "",
  addr = "",
  rating = 0,
  name = "",
  id="",
  open = false,
}) => {

  const rating_digits = parseFloat(rating).toFixed(1);
  const navigate = useNavigate();

  const handleCardClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/vendor-info/${id}/${name}`);
};

  
  return (
   <Link to={`/vendor-info/${id}/${name}`}>
    <Card
      variant="outlined"
      onClick={handleCardClick}
      sx={{
        borderRadius: "15px",
        height: { xs: "auto", sm: "210px" },
        transition: "transform 0.3s, border 0.3s",
        "&:hover": {
          transform: "translateY(-4px)",
        },
      }}
    >
      <CardContent className="product-card-content" sx={{ padding: "16px" }}>
        <div className={`restaurant-img-wrapper ${open ? '' : 'close-res'}`} style={{ position: "relative" }}>
          <Link>
            <CardMedia
              component="img"
              alt={title}
              image={image}
              sx={{
                objectFit: "cover",
                height: {
                  xs: "80px",
                  sm: "80px",
                  md: "80px",
                  lg: "80px",
                  xl: "80px",
                },
                width: "100%",
                borderRadius: "10px",
              }}
            />
          </Link>
          
          {/* Overlay for closed restaurants */}
          {!open && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(171, 0, 13, 0.7)", // Light red background
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "10px",
              }}
            >
              <Typography
                variant="h6"
                sx={{ color: "#fff", fontWeight: "bold" }}
              >
                Closed
              </Typography>
            </div>
          )}
        </div>

        <Link>
          <Typography
            variant="subtitle1"
            component="h6"
            className="bold"
            color="#000"
            fontSize={{ xs: 14, sm: 15 }}
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              mt: 1,
              mb: 1,
            }}
          >
            {title}
          </Typography>
        </Link>

        <Link>
          <CardActions sx={{ padding: 0, mb: 1 }}>
            <Typography
              variant="subtitle2"
              component="h6"
              fontSize={{ xs: 10, sm: 12 }}
              color="#000"
              sx={{
                flexGrow: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {addr.length > 28 ? `${des.substring(0, 20)}...` : addr}
            </Typography>
          </CardActions>
          <div className="border" />
        </Link>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "2px",
          }}
        >
          {rating > 0 && (
            <div
              className="rated"
              style={{ fontSize: "10px", display: "flex", alignItems: "center" }}
            >
              {rating_digits}
              <StarRateIcon sx={{ color: "#FFD700", fontSize: "14px", ml: 0.5 }} />
            </div>
          )}

          {open ? (
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: "9px",
                color: "green",
              }}
            >
              Currently Open
            </Typography>
          ) : (
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: "9px",
                color: "rgb(171, 0, 13)",
              }}
            >
              Currently closed
            </Typography>
          )}
        </div>
      </CardContent>
    </Card>
   </Link>
  );
};

export default VendorFlatCard;
